var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":_vm.type,"value-format":_vm.valueFormat,"format":_vm.valueFormat,"value":_vm.fildValue},on:{"input":_vm.changeValue}})}
var staticRenderFns = []

export { render, staticRenderFns }